import { render, staticRenderFns } from "./DietPage.vue?vue&type=template&id=cf36a520&scoped=true"
import script from "./DietPage.vue?vue&type=script&lang=js"
export * from "./DietPage.vue?vue&type=script&lang=js"
import style0 from "./DietPage.vue?vue&type=style&index=0&id=cf36a520&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf36a520",
  null
  
)

export default component.exports